import { IconName } from '../../components';
import { DateResource } from '../Date/Date';

export const isSilentLoop = {
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
};

export interface MediaFormatResource {
    hash: string;
    name: string;
    mime: string;
    ext?: string;
    size: number;
    width?: number;
    height?: number;
    url: string;
}

export enum ImageFormatSize {
    original = 'original',
    large = 'large',
    medium = 'medium',
    small = 'small',
    thumbnail = 'thumbnail',
}

export enum VideoFormatSize {
    large = 'large',
    small = 'small',
}

export interface MediaResource {
    name: string;
    alternativeText?: string;
    caption?: string;
    width?: number;
    height?: number;
    formats?: Partial<Record<ImageFormatSize, MediaFormatResource>>;
    hash: string;
    ext?: string;
    mime: string;
    size: number;
    url: string;
    previewUrl?: string;
    provider_metadata?: unknown;
    related?: unknown;
    createdAt?: DateResource;
    updatedAt?: DateResource;
}

export enum AutoplayMediaOption {
    none = 'none',
    autoPlay = 'autoplay',
    theatrePlay = 'theater play',
}

export interface MediaItemResource {
    id?: number;
    playOption: AutoplayMediaOption;
    media?: MediaResource;
}

interface FormatBase {
    type: string;
    media: string;
}

export interface ImageFormat extends FormatBase {
    srcSet: string;
}

export interface VideoFormat extends FormatBase {
    src: string;
}

export interface ImageBase {
    src: string;
    alt: string;
}

export interface Image extends ImageBase {
    formats: Partial<Record<ImageFormatSize, ImageFormat>>;
}

export enum VideoDeviceTypeResource {
    mobile = 'Mobile',
    desktop = 'Desktop',
}

export interface VideoResource {
    id: number;
    video: MediaResource;
    poster: MediaResource;
    deviceType: VideoDeviceTypeResource;
}

export interface Video {
    src?: string;
    type: string;
    poster?: Image;
    formats?: Partial<Record<ImageFormatSize, VideoFormat>>;
}

export interface MediaItem {
    id: string;
    image?: Image;
    video?: Video;
    videoPlaysInline?: boolean;
}

export interface IconResource {
    id: number;
    icon: IconName;
}
